import PropTypes from 'prop-types';
import React from 'react';
import SessionStore from 'stores/SessionStore';
import AdminShipperDetails from './admin-shipper-details';
import DefaultShipperDetails from './default-shipper-details';
class ShipperDetails extends React.Component {
    render() {
        const isAdmin = SessionStore.isAdmin();
        return isAdmin ? (React.createElement(AdminShipperDetails, Object.assign({}, this.props))) : (React.createElement(DefaultShipperDetails, Object.assign({}, this.props)));
    }
}
ShipperDetails.propTypes = {
    details: PropTypes.object.isRequired,
    transactions: PropTypes.array.isRequired,
    onOpenPassword: PropTypes.func.isRequired,
    onSaveDetails: PropTypes.func.isRequired,
    onSaveOrigin: PropTypes.func.isRequired,
    onLogoUpdate: PropTypes.func.isRequired,
    onSaveCreditCard: PropTypes.func.isRequired,
    onSaveBillingAddress: PropTypes.func.isRequired,
    onOpenJobs: PropTypes.func.isRequired,
    onCustomerPreferencesChange: PropTypes.func.isRequired,
    onOpenAccountRequest: PropTypes.func.isRequired,
};
export default ShipperDetails;
